import { render, staticRenderFns } from "./PaypalCheckoutAccount.vue?vue&type=template&id=8f12ffb6"
import script from "./PaypalCheckoutAccount.vue?vue&type=script&lang=js"
export * from "./PaypalCheckoutAccount.vue?vue&type=script&lang=js"
import style0 from "./PaypalCheckoutAccount.vue?vue&type=style&index=0&id=8f12ffb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports